module.exports = __webpack_public_path__ + "img/craig.b9b3800c.png";